const ROUTES = {
  home: '/',
  notAuthorized: '/not-authorized',
};
const ADMIN_ROUTES = {
  admin: '/admin',
  dashboardPage: '/admin/dashboard',
  dashboardList: 'list',
  dashboardNotification: 'notification',
  adminProfile: '/admin/profile',
  // CLIENT
  clients: '/admin/clients',
  client: '/admin/clients',
  clientGeneral: 'general',
  clientManagement: 'management',
  clientShipping: 'shipping',
  clientLogs: 'logs',
  clientTasks: 'tasks',
  clientTaskCreate: '/admin/clients/tasks/create',
  payments: 'payments',
  communicationHub: 'communication-hub',
  brand: {
    list: '/admin/brands',
    view: '/admin/brands',
    catalogue: 'catalogue',
    pricingAndSuppliers: 'pricingAndSuppliers',
    management: 'management',
    deals: 'deals',
    pricelists: 'pricelists',
    tasks: 'tasks',
    createTask: '/admin/brands/tasks/create',
    communicationHub: 'communication-hub',
    attachments: 'attachments',
    analytics: 'analytics',
    logs: 'logs',
  },
  suppliers: {
    list: '/admin/suppliers',
    view: '/admin/suppliers',
    general: 'general',
    priceLists: 'price-lists',
    shipping: 'shipping',
    pricing: 'pricing',
    management: 'management',
    communicationHub: 'communication-hub',
    tasks: 'tasks',
    createTask: '/admin/suppliers/tasks/create',
    attachments: 'attachments',
    logs: 'logs',

    catalogue: 'catalogue',
    deals: 'deals',
    analytics: 'analytics',
  },
  country: {
    list: '/admin/countries',
    view: '/admin/countries',
    pricing: 'pricing',
    shipping: 'shipping',
    warehouses: 'warehouses',
    tasks: 'tasks',
    createTask: '/admin/countries/tasks/create',
    management: 'management',
    logs: 'logs',
  },
  users: {
    list: '/admin/users',
    view: '/admin/users',
    create: '/admin/users/create',
    update: '/admin/users/update',
    account: 'account',
    attachments: 'attachments',
    logs: 'logs',
  },
  role: {
    list: '/admin/roles',
    view: '/admin/roles',
    create: '/admin/roles/create',
    update: '/admin/roles/update',
    permissions: 'permissions',
    logs: 'logs',
  },
  tasks: {
    list: '/admin/tasks',
    view: '/admin/tasks',
    create: '/admin/tasks/create',
    general: 'general',
    attachments: 'attachments',
    logs: 'logs',
  },
  // LEADS
  leads: {
    list: '/admin/leads',
    view: '/admin/leads',
    create: '/admin/leads/create',
    general: 'general',
    communicationHub: 'communication-hub',
    tasks: 'tasks',
    createTask: '/admin/leads/tasks/create',
    attachments: 'attachments',
    logs: 'logs',
  },
  // ORDERS
  orders: {
    list: '/admin/orders',
    view: '/admin/orders',
    create: '/admin/orders/create',
    general: 'general',
    communicationHub: 'communication-hub',
    tasks: 'tasks',
    createTask: '/admin/orders/tasks/create',
    attachments: 'attachments',
    logs: 'logs',
  },
  // DEALS
  deals: {
    list: '/admin/deals',
    view: '/admin/deals',
    purchaseRequest: 'purchase-request',
    commercialOffers: 'commercial-offers',
    commercialOfferUpdate: 'commercial-offer/update',
    communicationHub: 'communication-hub',
    tasks: 'tasks',
    createTask: '/admin/deals/tasks/create',
    attachments: 'attachments',
    logs: 'logs',
    sendCommercialOffers: '/admin/deals/:id/commercial-offers/send/:offerId',
  },
  // PURCHASE ORDER
  purchaseOrder: {
    list: '/admin/purchase-order',
    view: '/admin/purchase-order',
    create: '/admin/purchase-order/create',
    supplierOfferUpdate: '/admin/purchase-order/:source/:entityId/supplier-offer-update/:supplierOfferId',
    general: 'general',
    commercialOffers: 'commercial-offers',
    commercialOfferUpdate: 'commercial-offer/update',
    communicationHub: 'communication-hub',
    tasks: 'tasks',
    createTask: '/admin/deals/tasks/create',
    attachments: 'attachments',
    logs: 'logs',
    sendCommercialOffers: '/admin/deals/:id/commercial-offers/send/:offerId',
    requestPrice: '/admin/purchase-order/request-price',
  },
  // ITEMS
  items: {
    list: '/admin/items',
    view: '/admin/items',
    suppliers: 'suppliers',
    communicationHub: 'communication-hub',
    tasks: 'tasks',
    createTask: '/admin/items/tasks/create',
    attachments: 'attachments',
    logs: 'logs',
  },
  purchaseRequest: {
    list: '/admin/purchase-request',
    view: '/admin/purchase-request',
    supplierOfferUpdate: 'supplier-offer/update/:source/:supplierOfferId`',
    general: 'general',
    supplierOffers: 'supplier-offers',
    communicationHub: 'communication-hub',
    tasks: 'tasks',
    createTask: '/admin/purchase-request/tasks/create',
    attachments: 'attachments',
    logs: 'logs',
    requestPrice: '/admin/purchase-request/:id/request-price',
  },
  supplierOffer: {
    list: '/admin/supplier-offer',
    supplierOfferUpdate: '/admin/supplier-offer/:type/:source/update/:supplierOfferId',
  },
  adminSignIn: '/auth/admin/sign-in',
  adminForgotPassword: '/auth/admin/forgot-password',
  adminResetPassword: '/auth/admin/reset-password',
  adminResetPasswordSuccess: '/auth/admin/success-password',
};

const WAREHOUSE_ROUTES = {
  // Auth routes
  warehouseSignIn: '/auth/warehouse/sign-in',
  warehouseForgotPassword: '/auth/warehouse/forgot-password',
  warehouseResetPassword: '/auth/warehouse/reset-password',
  warehouseResetPasswordSuccess: '/auth/warehouse/success-password',

  // Main warehouse routes
  warehouse: '/warehouse',
  warehouseProfile: '/warehouse/profile',

  // Operations routes
  operations: '/warehouse/operations',
  inboundPackages: '/warehouse/inbound',
  outboundPackages: '/warehouse/outbound',
  outboundOrderDetails: '/warehouse/outbound/:id',
  uploadDeliveryNote: '/warehouse/upload-delivery-note',
  noOrdersFound: '/warehouse/no-orders-found',
  possibleOrders: '/warehouse/possible-orders',

  // Scan item flow
  captureItem: '/warehouse/inbound/:id/capture',
  itemDetails: '/warehouse/inbound/:id/details',
  packaging: '/warehouse/inbound/:id/packaging',
  fullPackageAndDimensions: '/warehouse/inbound/:id/full-package-dimensions',
  labels: '/warehouse/inbound/:id/labels',
  labelPrint: '/warehouse/inbound/:id/label-print',
  raiseClaim: '/warehouse/inbound/:id/raise-claim',

  // Future operations (for scalability)
  inventory: '/warehouse/inventory',
  reports: '/warehouse/reports',
  scanner: '/warehouse/scanner',

  // Relative paths (used in nested routing)
  relative: {
    signIn: 'sign-in',
    forgotPassword: 'forgot-password',
    resetPassword: 'reset-password',
    resetPasswordSuccess: 'success-password',
    profile: 'profile',
    operations: 'operations',
    inboundPackages: 'inbound',
    outboundPackages: 'outbound',
    uploadDeliveryNote: 'upload-delivery-note',
    noOrdersFound: 'no-orders-found',
    possibleOrders: 'possible-orders',
    inventory: 'inventory',
    reports: 'reports',
    scanner: 'scanner',
  },
};

export { ROUTES, ADMIN_ROUTES, WAREHOUSE_ROUTES };
